import { Typography } from "@mui/material";
import { AUDIT_TRAIL_ACTION } from "common";
import { EAuditTrailAction } from "model/Type/EAuditTrailAction";
import { I18nTranslator } from "utils/i18n";

const AuditTrailActionCell = ({ value }: { value: EAuditTrailAction }) => {
  const getColor = (value?: EAuditTrailAction) => {
    switch (value) {
      case EAuditTrailAction.LOGIN:
        return "#b5485f";
      case EAuditTrailAction.INSERT:
        return "#b32900";
      case EAuditTrailAction.UPDATE:
        return "#095169";
      case EAuditTrailAction.DELETE:
        return "#8338EC";
      case EAuditTrailAction.CONFIG:
        return "#481E81";
      case EAuditTrailAction.PRINT:
        return "#F06645";
      case EAuditTrailAction.SCAN_EMPLOYEE:
        return "#FF0270";
      case EAuditTrailAction.SCAN_CARTON:
        return "#031c30";
      case EAuditTrailAction.SCAN_CUSTOMER:
        return "#3D1309";
      case EAuditTrailAction.SCAN_PRODUCT_LOT:
        return "#30AAB9";
      case EAuditTrailAction.SCAN_PALLET:
        return "#028f76";
      case EAuditTrailAction.SCAN_PRODUCT:
        return "#7ab317";
      case EAuditTrailAction.SCAN_END:
        return "#668284";
      case EAuditTrailAction.SCAN_DESTROY_LABEL:
        return "#2a2829";
      case EAuditTrailAction.SCAN_DESTROY_LABEL_END:
        return "#493736";
      case EAuditTrailAction.SCAN_DESTROY_LABEL_FORCE_END:
        return "#c04848";
      case EAuditTrailAction.SCAN_TAKE_SAMPLE:
        return "#f07241";
      case EAuditTrailAction.SCAN_TAKE_SAMPLE_END:
        return "#f38630";
      case EAuditTrailAction.SCAN_EXPORT_NOTE:
        return "#c78933";
      case EAuditTrailAction.SCAN_BARCODE_INVALID:
        return "#038bbb";
      case EAuditTrailAction.SCAN_SPLIT_NOTE:
        return "#355c7d";
      case EAuditTrailAction.SCAN_PREPARE_NOTE:
        return "#6c5b7b";
      case EAuditTrailAction.SCAN_DELIVERY_NOTE:
        return "#506266";
      case EAuditTrailAction.SCAN_DRIVER_SIGN:
        return "#005bc5";
      case EAuditTrailAction.PRINT_CARTON_LABEL:
        return "#336666";
      case EAuditTrailAction.PRINT_PALLET_LABEL:
        return "#8d7966";
      case EAuditTrailAction.EXPORT_CARTON_BARCODE:
        return "#ff6600";
      case EAuditTrailAction.EXPORT_PRODUCT_BARCODE:
        return "#7cb490";
      case EAuditTrailAction.GENERATE_CARTON_BARCODE:
        return "#340a0b";
      case EAuditTrailAction.GENERATE_PRODUCT_BARCODE:
        return "#2e1437";
      case EAuditTrailAction.AUTO_RECEIVE_PRODUCT:
        return "#FF0270";
    }
  };
  return (
    <Typography
      sx={{
        backgroundColor: getColor(value),
        padding: "3px 16px",
        borderRadius: "3px",
        color: "white",
        fontWeight: "bold",
      }}
    >
      {I18nTranslator(
        AUDIT_TRAIL_ACTION.find((status) => status.type === value)?.name!
      )}
    </Typography>
  );
};

export default AuditTrailActionCell;
